/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Supported social media platforms
 * @export
 */
export const SocialPlatformType = {
    TWITCH: 'TWITCH',
    TWITCH_TEAM: 'TWITCH_TEAM',
    YOUTUBE: 'YOUTUBE',
    KICK: 'KICK',
    DISCORD: 'DISCORD',
    TWITTER: 'TWITTER',
    TIKTOK: 'TIKTOK',
    INSTAGRAM: 'INSTAGRAM',
    FACEBOOK: 'FACEBOOK',
    SNAPCHAT: 'SNAPCHAT',
    STREAMLABS: 'STREAMLABS',
    OTHER: 'OTHER'
} as const;
export type SocialPlatformType = typeof SocialPlatformType[keyof typeof SocialPlatformType];


export function instanceOfSocialPlatformType(value: any): boolean {
    for (const key in SocialPlatformType) {
        if (Object.prototype.hasOwnProperty.call(SocialPlatformType, key)) {
            if (SocialPlatformType[key as keyof typeof SocialPlatformType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SocialPlatformTypeFromJSON(json: any): SocialPlatformType {
    return SocialPlatformTypeFromJSONTyped(json, false);
}

export function SocialPlatformTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocialPlatformType {
    return json as SocialPlatformType;
}

export function SocialPlatformTypeToJSON(value?: SocialPlatformType | null): any {
    return value as any;
}

export function SocialPlatformTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SocialPlatformType {
    return value as SocialPlatformType;
}

